import React from 'react';

// import icons
import IconArrowLeft from 'js/components/icon/Icon.arrow-left';

const ButtonBack = ({ action }) => {
  return (
    <button className={'button--back'} onClick={action} aria-label="Back" id="button-back-arrow">
      <IconArrowLeft />
    </button>
  );
};

export default ButtonBack;
